<template>
  <div class="table-responsive mt-3" style="overflow: auto; padding-bottom: 30px; max-height: 70vh">
    <table class="table">
      <thead style="border: 1px solid lightgray">
      <tr style="background: #472F92 !important; color: white">
        <th style="width: 100px; white-space: nowrap">Mã NS</th>
        <th style="width: 120px; white-space: nowrap">Điểm trừ</th>
        <th style="width: 80px; white-space: nowrap">Quý</th>
        <th style="width: 80px; word-break: break-word">Năm</th>
        <th style="width: 200px; word-break: break-word">Mô tả</th>
        <th style="width: 240px; word-break: break-word">Lỗi</th>
      </tr>
      </thead>
      <tbody style="border: 1px solid lightgray">
      <tr v-for="item of responseError" :key="item?.index">
        <td style="text-align: start">{{ item?.userId }}</td>
        <td style="text-align: start">{{ item?.point }}</td>
        <td style="text-align: start; word-break: break-word">{{ item?.quarter }}</td>
        <td style="text-align: start; white-space: nowrap">{{ item?.year }}</td>
        <td style="text-align: start">
          <el-tooltip class="item" effect="dark" :content="item.description" placement="top">
            <span class="line-clamp-1" style="word-break: break-word">{{ item.description }}</span>
          </el-tooltip>
        </td>
        <td>
          <div v-if="item.error?.length > 0" style="text-align: start; display: flex; flex-direction: column">
            <span v-for="(err, index) in item.error" :key="index + err" style="word-break: break-word; color: red">
              {{err}}
            </span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TableErrorImportMinusPoint',
  data() {
    return {}
  },
  props: {
    responseError: {
      type: Array,
      default: []
    }
  },
  methods: {}
}
</script>

<style lang="css" scoped>
.header-table {
  background: #F8F8F8;
  text-align: start;
  word-break: break-word;
}
</style>